import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class EventsService {
  constructor(
    private _httpClient: HttpClient,
    private helper: HelperService,
    private postService: PostService
  ) {}

  getEvents = (
    parameters: any,
    start: string,
    end: string
  ): Observable<any> => {
    // const formData = new FormData();

    // console.log(parameters);

   var data = this.helper.getPlaceIdAndGroupId(parameters);

  //  console.log(data)

  //  formData.append("party_post_id", parameters.party_post_id);
  //  formData.append("group_id", JSON.stringify(data.group_id) );
  //  formData.append("place_id", data.place_id);

    

  //   if (parameters.event_level == "country") {
  //     formData.append("getEventsByCountryId", "1");
  //     formData.append("country_id", parameters.country_id);
  //     formData.append("includeDeleted", "1");
  //     formData.append("party_post_group_id", parameters.party_post_group_id);
  //     formData.append("party_post_id", parameters.party_post_id);
  //   } else {
  //     formData.append("getEventsByConstId", "1");
  //     formData.append("const_id", parameters.const_id);
  //     formData.append("includeDeleted", "1");
  //     formData.append("party_post_group_id", parameters.party_post_group_id);
  //     formData.append("party_post_id", parameters.party_post_id);
  //   }

  //   formData.append(
  //     "filter",
  //     JSON.stringify({
  //       start: start,
  //       end: end,
  //       barrack: -1,
  //     })
  //   );

    
  let params = ""
  params = "party_post_id=" + parameters.party_post_id;
  params = params +"&group_id=" + data.group_id;
  params = params + "&place_id=" + data.place_id;
  params = params + "&from="+start;
  params = params + "&to=" + end;

  // Todo: This should be added only if checkbox checked.
  params =params +"&sub_levels=1"

    return this.postService.get(environment.API_LIST_EVENT+"?" + params);
  };

  //   resolve(
  //     route: ActivatedRouteSnapshot,
  //     state: RouterStateSnapshot,
  //   ): Observable<any> | Promise<any> | any {
  //     return new Promise((resolve, reject) => {
  //       Promise.all([this.getEvents()]).then(([events]: [any]) => {
  //         resolve();
  //       }, reject);
  //     });
  //   }

  //   getEvents(): Promise<any> {
  //     return new Promise((resolve, reject) => {
  //       this._httpClient.get("api/calendar/events").subscribe((response: any) => {
  //         this.events = response.data;
  //         this.onEventsUpdated.next(this.events);
  //         resolve(this.events);
  //       }, reject);
  //     });
  //   }

  //   updateEvents(events): Promise<any> {
  //     return new Promise((resolve, reject) => {
  //       this._httpClient
  //         .post("api/calendar/events", {
  //           id: "events",
  //           data: [...events],
  //         })
  //         .subscribe((response: any) => {
  //           this.getEvents();
  //         }, reject);
  //     });
  //   }
}
